export default "__VITE_ASSET__UXh_iHWI__"